import {createRoot} from 'react-dom/client'
// Axios
import axios from 'axios'
import {Chart, registerables} from 'chart.js'
import {DndProvider} from 'react-dnd'
import {HTML5Backend} from 'react-dnd-html5-backend'
import {QueryClientProvider} from 'react-query'
import {ReactQueryDevtools} from 'react-query/devtools'
import {BrowserRouter, Route, Routes} from 'react-router-dom'
// Apps
import SandBox from 'app/pages/admin/sandbox'
import InviteLanding from 'app/pages/invite/InviteLanding'
import Signup from 'app/pages/signup/SignUpLanding'
import {queryClient} from 'app/react-query'
import 'react-dropzone-uploader/dist/styles.css'
import 'react-loading-skeleton/dist/skeleton.css'
import {Provider} from 'react-redux'
import {store} from 'redux/store'
import 'style.css'

import AuthProvider from 'app/modules/auth/core/Auth'
import Privacy from 'app/pages/privacy'
import Terms from 'app/pages/terms'
import {authenticate, setupAxios} from './app/modules/cognito'
import {ErrorsPage} from './app/modules/errors/ErrorsPage'
import {About, Home, Pricing} from './app/pages/home'
import {Hypersonic} from './app/pages/home/Hypersonic'
import Register from './app/pages/home/register'
import {AppRoutes} from './app/routing/AppRoutes'

/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */

// Wrapping setup in a function call so we can use await() at the top level.
async function load() {
  const {PUBLIC_URL} = process.env
  const url = new URL(window.location.href)
  if (
    !window.location.href.includes('code') &&
    !window.location.href.includes('state') &&
    (url.pathname === '/' ||
      url.pathname === '/about' ||
      url.pathname === '/pricing' ||
      url.pathname === '/privacy' ||
      url.pathname === '/terms' ||
      url.pathname.includes('register') ||
      url.pathname.includes('hypersonic') ||
      // url.pathname.includes('profilewizard') ||
      url.pathname.includes('invite') ||
      // url.pathname.includes('onboarding') ||
      url.pathname.includes('signup') ||
      url.pathname.includes('sandbox'))
  ) {
    const container = document.getElementById('root')
    if (container) {
      createRoot(container).render(
        <QueryClientProvider client={queryClient}>
          <BrowserRouter basename={PUBLIC_URL}>
            <Routes>
              <Route path='/' element={<Home />} />
              <Route path='about' element={<About />} />
              <Route path='pricing' element={<Pricing />} />
              <Route path='hypersonic' element={<Hypersonic />} />
              <Route path='register' element={<Register />} />
              <Route path='signup' element={<Signup />} />
              <Route path='invite' element={<InviteLanding loggedIn={false} />} />
              <Route path='error/*' element={<ErrorsPage />} />
              <Route path='sandbox/*' element={<SandBox />} />
              <Route path='privacy' element={<Privacy />} />
              <Route path='terms' element={<Terms />} />
            </Routes>
          </BrowserRouter>
        </QueryClientProvider>
      )
    }
  } else {
    setupAxios(axios)

    const {redirect} = await authenticate()

    if (redirect) {
      // We are about to redirect away to Cognito. Don't bother rendering the page.
      return
    }

    Chart.register(...registerables)
    const container = document.getElementById('root')
    if (container) {
      createRoot(container).render(
        <Provider store={store}>
          <DndProvider backend={HTML5Backend}>
            <QueryClientProvider client={queryClient}>
              <AuthProvider>
                <AppRoutes />
              </AuthProvider>
              {false && 'enableForQueryTools' && <ReactQueryDevtools initialIsOpen={false} />}
            </QueryClientProvider>
          </DndProvider>
        </Provider>
      )
    }
  }
}

load()
